import React from 'react';

export const IconCross = (props: { color: string; size: number }) => (
  <svg width={props.size} height={props.size} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M1 1L10.5 10.5' stroke={`${props.color}`} stroke-width='2.5' />
    <path d='M10.5 1L1 10.5' stroke={`${props.color}`} stroke-width='2.5' />
  </svg>
);
